module.exports = __webpack_public_path__ + "media/images/territory_landing_pages/hero_banner/component/beauty-mobile@3x-61c22b9d8156fd3cbeb97e3cb7e42985.jpg";